import React, { useState } from "react";
import Button from "../../../../../../components/ui/Button";
import { Check } from "lucide-react";
import CheckoutModal from "../../../../../../components/shared/CheckoutModal"; // ✨ Import the new modal

const SubscriptionTierCard = ({ tier }) => {
  const [isCheckoutOpen, setCheckoutOpen] = useState(false);

  if (!tier) return null;

  return (
    <>
      <div className="bg-white p-6 rounded-xl border-2 border-slate-200 hover:border-primary transition-all">
        <div className="flex items-center gap-3">
          {tier.logoUrl && (
            <img
              src={tier.logoUrl}
              alt={tier.platform}
              className="w-10 h-10 rounded-full bg-slate-100"
            />
          )}
          <div>
            <h3 className="font-bold text-slate-800">{tier.name}</h3>
            <p className="text-sm font-semibold text-primary">
              {tier.priceETB} ETB{" "}
              <span className="text-slate-500 font-normal">/ month</span>
            </p>
          </div>
        </div>

        {tier.perks && (
          <ul className="my-4 space-y-2">
            {tier.perks.map((perk, index) => (
              <li
                key={index}
                className="flex items-start gap-2 text-sm text-slate-600"
              >
                <Check
                  size={16}
                  className="text-green-500 mt-0.5 flex-shrink-0"
                />
                <span>{perk}</span>
              </li>
            ))}
          </ul>
        )}

        {/* ✨ This button now opens the checkout modal */}
        <Button onClick={() => setCheckoutOpen(true)} className="w-full mt-2">
          Subscribe
        </Button>
      </div>

      {/* The Modal component itself, controlled by this card's state */}
      <CheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setCheckoutOpen(false)}
        item={tier} // Pass the tier information to the modal
      />
    </>
  );
};

export default SubscriptionTierCard;
